import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-100 flex items-center justify-center" }
const _hoisted_2 = { class: "max-w-md w-full bg-white rounded-lg shadow-md p-8" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "text-red-600 text-sm text-center"
}
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mb-8 text-center" }, [
        _createElementVNode("h2", { class: "text-3xl font-bold text-gray-900" }, "Accesso Amministratore"),
        _createElementVNode("p", { class: "mt-2 text-sm text-gray-600" }, "Inserisci le tue credenziali per accedere")
      ], -1)),
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleLogin && _ctx.handleLogin(...args)), ["prevent"])),
        class: "space-y-6"
      }, [
        _createElementVNode("div", null, [
          _cache[3] || (_cache[3] = _createElementVNode("label", {
            for: "username",
            class: "block text-sm font-medium text-gray-700"
          }, " Username ", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "username",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
            type: "text",
            required: "",
            disabled: _ctx.isLoading,
            class: "mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100",
            placeholder: "Inserisci username"
          }, null, 8, _hoisted_3), [
            [_vModelText, _ctx.username]
          ])
        ]),
        _createElementVNode("div", null, [
          _cache[4] || (_cache[4] = _createElementVNode("label", {
            for: "password",
            class: "block text-sm font-medium text-gray-700"
          }, " Password ", -1)),
          _withDirectives(_createElementVNode("input", {
            id: "password",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
            type: "password",
            required: "",
            disabled: _ctx.isLoading,
            class: "mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100",
            placeholder: "Inserisci password"
          }, null, 8, _hoisted_4), [
            [_vModelText, _ctx.password]
          ])
        ]),
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "submit",
            disabled: _ctx.isLoading,
            class: "group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          }, [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _cache[5] || (_cache[5] = [
                  _createElementVNode("svg", {
                    class: "animate-spin h-4 w-4",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("circle", {
                      class: "opacity-25",
                      cx: "12",
                      cy: "12",
                      r: "10",
                      stroke: "currentColor",
                      "stroke-width": "4"
                    }),
                    _createElementVNode("path", {
                      class: "opacity-75",
                      fill: "currentColor",
                      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    })
                  ], -1)
                ])))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.isLoading ? 'Accesso in corso...' : 'Accedi'), 1)
          ], 8, _hoisted_6)
        ])
      ], 32)
    ])
  ]))
}